module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "group group--first-last-small"
  }, _vm._l((_vm.sections), function(content, index) {
    return _c('div', {
      key: index,
      staticClass: "mt2"
    }, [_c('h3', {
      staticClass: "h3 mt0"
    }, [_vm._v(_vm._s(content.title))]), _vm._v(" "), _vm._l((content.copy), function(paragraph, index) {
      return _c('p', {
        key: index,
        staticClass: "p mw-100",
        domProps: {
          "innerHTML": _vm._s(paragraph)
        }
      })
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a7568f1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/understandingYourReport/Info.vue
// module id = 294
// module chunks = 0